module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Schattdorf-fcf3d11efc966e9fd2f3d4331c074d2f.svg";